// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1_wso","cls2":"NewsInteractionBar-cls2_M2a NewsInteractionBar-cls1_wso"};